<lib-dm-button-lib
  text="Select Template"
  size="medium"
  variant="secondary-filled"
  (outsideClickEmitter)="op.toggle($event); $event.stopPropagation();"
>
  <div class="dm-button-icon" icon-right>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.41009 6.91075C4.73553 6.58531 5.26317 6.58531 5.5886 6.91075L9.99935 11.3215L14.4101 6.91075C14.7355 6.58531 15.2632 6.58531 15.5886 6.91075C15.914 7.23618 15.914 7.76382 15.5886 8.08926L10.5886 13.0893C10.2632 13.4147 9.73553 13.4147 9.41009 13.0893L4.41009 8.08926C4.08466 7.76382 4.08466 7.23618 4.41009 6.91075Z"
        fill="white"
      />
    </svg>
  </div>
</lib-dm-button-lib>
<p-popover #op>
  <div class="popover-container">
    @if(filteredUnselectedFields && filteredUnselectedFields && !loading()) {
    <div class="template-list-search">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        class="search-icon"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.58268 3.33329C6.1309 3.33329 3.33268 6.13151 3.33268 9.58329C3.33268 13.0351 6.1309 15.8333 9.58268 15.8333C11.2603 15.8333 12.7835 15.1723 13.9061 14.0967C13.932 14.0607 13.9612 14.0264 13.9935 13.994C14.0259 13.9617 14.0602 13.9326 14.0961 13.9067C15.1718 12.784 15.8327 11.2608 15.8327 9.58329C15.8327 6.13151 13.0345 3.33329 9.58268 3.33329ZM15.739 14.561C16.8399 13.2011 17.4993 11.4692 17.4993 9.58329C17.4993 5.21104 13.9549 1.66663 9.58268 1.66663C5.21043 1.66663 1.66602 5.21104 1.66602 9.58329C1.66602 13.9555 5.21043 17.5 9.58268 17.5C11.4687 17.5 13.2006 16.8405 14.5605 15.7395L16.9101 18.0892C17.2355 18.4146 17.7632 18.4147 18.0886 18.0892C18.414 17.7638 18.414 17.2362 18.0886 16.9107L15.739 14.561Z"
          fill="#5D6983"
        />
      </svg>
      <input
        [(ngModel)]="searchQuery"
        id="inputRangePicker"
        placeholder="Enter Template Name"
        class="form-control-field search-input"
        pInputText
      />
      @if(searchQuery) {
      <svg
        (click)="searchQuery = ''"
        class="clear-icon"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M8.01186 7.00933L12.27 2.75116C12.341 2.68501 12.398 2.60524 12.4375 2.51661C12.4769 2.42798 12.4982 2.3323 12.4999 2.23529C12.5016 2.13827 12.4838 2.0419 12.4474 1.95194C12.4111 1.86197 12.357 1.78024 12.2884 1.71163C12.2198 1.64302 12.138 1.58893 12.0481 1.55259C11.9581 1.51625 11.8617 1.4984 11.7647 1.50011C11.6677 1.50182 11.572 1.52306 11.4834 1.56255C11.3948 1.60204 11.315 1.65898 11.2488 1.72997L6.99067 5.98814L2.7325 1.72997C2.59553 1.60234 2.41437 1.53286 2.22718 1.53616C2.03999 1.53946 1.8614 1.61529 1.72901 1.74767C1.59663 1.88006 1.5208 2.05865 1.5175 2.24584C1.5142 2.43303 1.58368 2.61419 1.71131 2.75116L5.96948 7.00933L1.71131 11.2675C1.576 11.403 1.5 11.5866 1.5 11.7781C1.5 11.9696 1.576 12.1532 1.71131 12.2887C1.84679 12.424 2.03043 12.5 2.2219 12.5C2.41338 12.5 2.59702 12.424 2.7325 12.2887L6.99067 8.03052L11.2488 12.2887C11.3843 12.424 11.568 12.5 11.7594 12.5C11.9509 12.5 12.1346 12.424 12.27 12.2887C12.4053 12.1532 12.4813 11.9696 12.4813 11.7781C12.4813 11.5866 12.4053 11.403 12.27 11.2675L8.01186 7.00933Z"
          fill="#5D6983"
        ></path>
      </svg>
      }
    </div>
    }
    <div class="template-list">
      @if(!loading()) { @if(filteredUnselectedFields &&
      filteredUnselectedFields.length) {
      <div class="template-row template-row-header">
        <div class="cell cell-header"><span>Template Name</span></div>
        <div class="cell cell-header"><span>Template Description</span></div>
        <div class="cell cell-header"><span>Actions</span></div>
      </div>
      @for (template of filteredUnselectedFields; track template.template_id;
      let i = $index) {
      <div
        class="template-row template-row-content"
        [ngClass]="{'selected-row': template.template_id === selectedTemplateId}"
      >
        <div
          class="cell cell-name"
          (click)="op.toggle($event); editTemplate(template)"
        >
          {{template.template_name}}
        </div>
        <div
          class="cell cell-desc"
          (click)="op.toggle($event); editTemplate(template)"
        >
          {{template.template_desc}}
        </div>
        <div class="cell cell-actions">
          <span
            class="action"
            (click)="runReport(template); op.toggle($event)"
            pTooltip="Run"
            tooltipPosition="top"
            positionTop="-5"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.66667 2.01323C8.54287 2.00195 8.35943 2 8.00785 2H5.86667C5.29561 2 4.90742 2.00052 4.60736 2.02504C4.31508 2.04892 4.16561 2.0922 4.06135 2.14533C3.81046 2.27316 3.60649 2.47713 3.47866 2.72801C3.42553 2.83228 3.38225 2.98175 3.35837 3.27403C3.33385 3.57409 3.33333 3.96228 3.33333 4.53333V11.4667C3.33333 12.0377 3.33385 12.4259 3.35837 12.726C3.38225 13.0183 3.42553 13.1677 3.47866 13.272C3.60649 13.5229 3.81046 13.7268 4.06135 13.8547C4.16561 13.9078 4.31508 13.9511 4.60736 13.975C4.90742 13.9995 5.29561 14 5.86667 14H10.1333C10.7044 14 11.0926 13.9995 11.3926 13.975C11.6849 13.9511 11.8344 13.9078 11.9387 13.8547C12.1895 13.7268 12.3935 13.5229 12.5213 13.272C12.5745 13.1677 12.6178 13.0183 12.6416 12.726C12.6661 12.4259 12.6667 12.0377 12.6667 11.4667V6.65882C12.6667 6.30728 12.6647 6.12385 12.6534 6.00005L10.3787 6.00005C10.2105 6.00007 10.0466 6.00009 9.90785 5.98875C9.75545 5.9763 9.57563 5.94692 9.39468 5.85472C9.1438 5.72689 8.93982 5.52292 8.81199 5.27204C8.71979 5.09109 8.69042 4.91126 8.67796 4.75887C8.66663 4.62009 8.66665 4.45623 8.66667 4.28797L8.66667 2.01323ZM9.59573 0.899979C9.44514 0.832472 9.28838 0.778989 9.12743 0.740348C8.81896 0.666293 8.4991 0.666445 8.07577 0.666647C8.05342 0.666657 8.03079 0.666668 8.00785 0.666668L5.83913 0.666668C5.30249 0.666659 4.85958 0.666652 4.49878 0.69613C4.12405 0.726747 3.77958 0.792457 3.45603 0.957317C2.95426 1.21298 2.54631 1.62093 2.29065 2.12269C2.12579 2.44625 2.06008 2.79072 2.02946 3.16545C1.99998 3.52625 1.99999 3.96915 2 4.5058V11.4942C1.99999 12.0308 1.99998 12.4738 2.02946 12.8346C2.06008 13.2093 2.12579 13.5538 2.29065 13.8773C2.54631 14.3791 2.95426 14.787 3.45603 15.0427C3.77958 15.2075 4.12405 15.2733 4.49878 15.3039C4.85958 15.3333 5.30248 15.3333 5.83912 15.3333H10.1609C10.6975 15.3333 11.1404 15.3333 11.5012 15.3039C11.876 15.2733 12.2204 15.2075 12.544 15.0427C13.0457 14.787 13.4537 14.3791 13.7094 13.8773C13.8742 13.5538 13.9399 13.2093 13.9705 12.8346C14 12.4738 14 12.0309 14 11.4942V6.65882C14 6.63588 14 6.61325 14 6.5909C14.0002 6.16757 14.0004 5.8477 13.9263 5.53924C13.8878 5.37876 13.8345 5.22244 13.7673 5.07225C13.7631 5.06246 13.7587 5.05279 13.7541 5.04325C13.7105 4.94899 13.6615 4.85722 13.607 4.76843C13.4413 4.49795 13.215 4.27188 12.9155 3.97268C12.8997 3.95688 12.8837 3.94089 12.8675 3.92467L10.742 1.79919C10.7258 1.78297 10.7098 1.76696 10.694 1.75115C10.3948 1.45166 10.1687 1.22538 9.89824 1.05963C9.80909 1.005 9.71693 0.955736 9.62227 0.912052C9.61353 0.907841 9.60468 0.903814 9.59573 0.899979ZM10 2.94281V4.26672C10 4.4644 10.0005 4.57257 10.0069 4.65029C10.0071 4.65339 10.0074 4.65632 10.0076 4.65908C10.0104 4.65934 10.0133 4.65959 10.0164 4.65985C10.0941 4.6662 10.2023 4.66672 10.4 4.66672H11.7239L10 2.94281ZM4.66667 8.66667C4.66667 8.29848 4.96514 8 5.33333 8H10.6667C11.0349 8 11.3333 8.29848 11.3333 8.66667C11.3333 9.03486 11.0349 9.33333 10.6667 9.33333H5.33333C4.96514 9.33333 4.66667 9.03486 4.66667 8.66667ZM4.66667 11.3333C4.66667 10.9651 4.96514 10.6667 5.33333 10.6667H9.33333C9.70152 10.6667 10 10.9651 10 11.3333C10 11.7015 9.70152 12 9.33333 12H5.33333C4.96514 12 4.66667 11.7015 4.66667 11.3333Z"
                fill="#5D6983"
              />
            </svg>
          </span>
          <span
            class="action"
            pTooltip="Download as .CSV"
            tooltipPosition="top"
            positionTop="-5"
            (click)="runCsv(template)"
          >
            @if(templateCsvLoadingIds.has(template.template_id)) {
            <p-progress-spinner
              strokeWidth="6"
              [style]="{ width: '16px', height: '16px' }"
            />
            } @else {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.00065 1.33334C8.36884 1.33334 8.66732 1.63182 8.66732 2.00001V8.39053L10.8626 6.19527C11.1229 5.93492 11.545 5.93492 11.8054 6.19527C12.0657 6.45562 12.0657 6.87773 11.8054 7.13808L8.47206 10.4714C8.21171 10.7318 7.7896 10.7318 7.52925 10.4714L4.19591 7.13808C3.93556 6.87773 3.93556 6.45562 4.19591 6.19527C4.45626 5.93492 4.87837 5.93492 5.13872 6.19527L7.33398 8.39053V2.00001C7.33398 1.63182 7.63246 1.33334 8.00065 1.33334ZM2.00065 9.33334C2.36884 9.33334 2.66732 9.63182 2.66732 10V10.8C2.66732 11.3711 2.66784 11.7593 2.69235 12.0593C2.71623 12.3516 2.75952 12.5011 2.81264 12.6053C2.94047 12.8562 3.14445 13.0602 3.39533 13.188C3.4996 13.2411 3.64907 13.2844 3.94134 13.3083C4.2414 13.3328 4.6296 13.3333 5.20065 13.3333H10.8007C11.3717 13.3333 11.7599 13.3328 12.06 13.3083C12.3522 13.2844 12.5017 13.2411 12.606 13.188C12.8569 13.0602 13.0608 12.8562 13.1887 12.6053C13.2418 12.5011 13.2851 12.3516 13.3089 12.0593C13.3335 11.7593 13.334 11.3711 13.334 10.8V10C13.334 9.63182 13.6325 9.33334 14.0007 9.33334C14.3688 9.33334 14.6673 9.63182 14.6673 10V10.8276C14.6673 11.3642 14.6673 11.8071 14.6379 12.1679C14.6072 12.5426 14.5415 12.8871 14.3767 13.2107C14.121 13.7124 13.7131 14.1204 13.2113 14.376C12.8877 14.5409 12.5433 14.6066 12.1685 14.6372C11.8077 14.6667 11.3648 14.6667 10.8282 14.6667H5.1731C4.63646 14.6667 4.19356 14.6667 3.83277 14.6372C3.45804 14.6066 3.11357 14.5409 2.79001 14.376C2.28824 14.1204 1.8803 13.7124 1.62463 13.2107C1.45977 12.8871 1.39406 12.5426 1.36345 12.1679C1.33397 11.8071 1.33398 11.3642 1.33398 10.8275L1.33398 10C1.33398 9.63182 1.63246 9.33334 2.00065 9.33334Z"
                fill="#5D6983"
              />
            </svg>
            }
          </span>
          <span
            [ngStyle]="{position: 'relative'}"
            (click)="showSendingModal.set(true); selectedTemplate = template"
            class="action"
            pTooltip="Send E-mail"
            tooltipPosition="top"
            positionTop="-5"
          >
            @if(template.input_params.send_option) {
            <span
              [ngStyle]="{position: 'absolute', width: '8px', height: '8px', background: '#2eb398', 'border-radius': '50%', right: '2px', top: '2px'}"
            ></span>
            }
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <g clip-path="url(#clip0_1459_10510)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.8893 4.05321L7.77869 9.16384L9.3341 13.1635L12.8893 4.05321ZM6.83588 8.22103L11.9465 3.1104L2.83626 6.66562L6.83588 8.22103ZM13.7648 0.982783C13.8869 0.94731 14.1325 0.883567 14.3964 0.97171C14.6945 1.0713 14.9284 1.30523 15.028 1.60333C15.1161 1.86718 15.0524 2.11281 15.0169 2.23494C14.9783 2.36803 14.9163 2.52664 14.8542 2.68578L10.4426 13.9905C10.3732 14.1684 10.306 14.3407 10.2402 14.4737C10.1834 14.5886 10.057 14.8328 9.79457 14.9691C9.5052 15.1195 9.1607 15.1193 8.8715 14.9686C8.60925 14.832 8.48308 14.5876 8.4264 14.4726C8.3608 14.3396 8.2938 14.1672 8.22462 13.9892L6.48466 9.51505L2.034 7.78424C2.02616 7.78119 2.01832 7.77814 2.0105 7.7751C1.83252 7.70592 1.66016 7.63891 1.5271 7.57331C1.41213 7.51663 1.16775 7.39046 1.03112 7.12822C0.880444 6.83902 0.880241 6.49452 1.03058 6.20514C1.1669 5.94274 1.41113 5.81628 1.52603 5.75947C1.65902 5.69371 1.8313 5.6265 2.00919 5.55711C2.01702 5.55406 2.02485 5.551 2.03269 5.54794L13.3139 1.14551C13.4731 1.08337 13.6317 1.02144 13.7648 0.982783Z"
                  fill="#5D6983"
                />
              </g>
              <defs>
                <clipPath id="clip0_1459_10510">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span
            class="action"
            (click)="duplicateTemplate(template, i)"
            pTooltip="Duplicate"
            tooltipPosition="top"
            positionTop="-5"
          >
            @if(templateDuplicateLoadingIds.has(template.template_id)) {
            <p-progress-spinner
              strokeWidth="6"
              [style]="{ width: '16px', height: '16px' }"
            />
            } @else {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <g clip-path="url(#clip0_1459_11002)">
                <path
                  d="M5.33398 5.33334V3.46668C5.33398 2.71994 5.33398 2.34657 5.47931 2.06136C5.60714 1.81047 5.81111 1.6065 6.062 1.47867C6.34721 1.33334 6.72058 1.33334 7.46732 1.33334H12.534C13.2807 1.33334 13.6541 1.33334 13.9393 1.47867C14.1902 1.6065 14.3942 1.81047 14.522 2.06136C14.6673 2.34657 14.6673 2.71994 14.6673 3.46668V8.53334C14.6673 9.28008 14.6673 9.65348 14.522 9.93868C14.3942 10.1895 14.1902 10.3935 13.9393 10.5213C13.6541 10.6667 13.2807 10.6667 12.534 10.6667H10.6673M3.46732 14.6667H8.53398C9.28072 14.6667 9.65412 14.6667 9.93932 14.5213C10.1902 14.3935 10.3942 14.1895 10.522 13.9387C10.6673 13.6535 10.6673 13.2801 10.6673 12.5333V7.46668C10.6673 6.71994 10.6673 6.34657 10.522 6.06136C10.3942 5.81047 10.1902 5.6065 9.93932 5.47867C9.65412 5.33334 9.28072 5.33334 8.53398 5.33334H3.46732C2.72058 5.33334 2.34721 5.33334 2.062 5.47867C1.81111 5.6065 1.60714 5.81047 1.47931 6.06136C1.33398 6.34657 1.33398 6.71994 1.33398 7.46668V12.5333C1.33398 13.2801 1.33398 13.6535 1.47931 13.9387C1.60714 14.1895 1.81111 14.3935 2.062 14.5213C2.34721 14.6667 2.72058 14.6667 3.46732 14.6667Z"
                  stroke="#5D6983"
                  stroke-width="1.6"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_1459_11002">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
            }
          </span>
          <span
            class="action"
            pTooltip="Delete"
            tooltipPosition="top"
            positionTop="-5"
            (click)="showDeleteConfirmation.set(true); selectedTemplateId = template.template_id; selectedTemplate = template; op.toggle($event)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.44162 0.666657H8.55968C8.91111 0.666645 9.21429 0.666635 9.464 0.687037C9.72757 0.708571 9.98971 0.756115 10.242 0.884645C10.6183 1.07639 10.9243 1.38235 11.116 1.75868C11.2445 2.01093 11.2921 2.27308 11.3136 2.53664C11.3319 2.76049 11.3338 3.0273 11.334 3.33332H14.0007C14.3688 3.33332 14.6673 3.6318 14.6673 3.99999C14.6673 4.36818 14.3688 4.66666 14.0007 4.66666H13.334V11.4942C13.334 12.0308 13.334 12.4737 13.3045 12.8345C13.2739 13.2093 13.2082 13.5537 13.0433 13.8773C12.7877 14.3791 12.3797 14.787 11.878 15.0427C11.5544 15.2075 11.2099 15.2732 10.8352 15.3039C10.4744 15.3333 10.0315 15.3333 9.49487 15.3333H6.50644C5.9698 15.3333 5.52689 15.3333 5.1661 15.3039C4.79137 15.2732 4.4469 15.2075 4.12334 15.0427C3.62158 14.787 3.21363 14.3791 2.95797 13.8773C2.79311 13.5537 2.7274 13.2093 2.69678 12.8345C2.6673 12.4737 2.66731 12.0308 2.66732 11.4942L2.66732 4.66666H2.00065C1.63246 4.66666 1.33398 4.36818 1.33398 3.99999C1.33398 3.6318 1.63246 3.33332 2.00065 3.33332H4.66734C4.66752 3.0273 4.66941 2.76049 4.6877 2.53664C4.70923 2.27308 4.75678 2.01093 4.8853 1.75868C5.07705 1.38235 5.38301 1.07639 5.75934 0.884645C6.01159 0.756115 6.27374 0.708571 6.5373 0.687037C6.78701 0.666635 7.09019 0.666645 7.44162 0.666657ZM4.00065 4.66666V11.4667C4.00065 12.0377 4.00117 12.4259 4.02569 12.726C4.04957 13.0182 4.09285 13.1677 4.14598 13.272C4.27381 13.5229 4.47778 13.7268 4.72866 13.8547C4.83293 13.9078 4.9824 13.9511 5.27468 13.975C5.57474 13.9995 5.96293 14 6.53398 14H9.46732C10.0384 14 10.4266 13.9995 10.7266 13.975C11.0189 13.9511 11.1684 13.9078 11.2726 13.8547C11.5235 13.7268 11.7275 13.5229 11.8553 13.272C11.9085 13.1677 11.9517 13.0182 11.9756 12.726C12.0001 12.4259 12.0007 12.0377 12.0007 11.4667V4.66666H4.00065ZM10.0006 3.33332H6.0007C6.00099 3.02326 6.00303 2.81131 6.0166 2.64522C6.0314 2.46411 6.05652 2.39696 6.07331 2.364C6.13723 2.23856 6.23922 2.13657 6.36466 2.07265C6.39762 2.05586 6.46477 2.03074 6.64588 2.01594C6.83477 2.00051 7.08295 1.99999 7.46732 1.99999H8.53398C8.91835 1.99999 9.16654 2.00051 9.35543 2.01594C9.53654 2.03074 9.60368 2.05586 9.63664 2.07265C9.76209 2.13657 9.86407 2.23856 9.92799 2.364C9.94478 2.39696 9.9699 2.46411 9.9847 2.64522C9.99827 2.81131 10.0003 3.02326 10.0006 3.33332ZM6.66732 6.99999C7.03551 6.99999 7.33398 7.29847 7.33398 7.66666V11C7.33398 11.3682 7.03551 11.6667 6.66732 11.6667C6.29913 11.6667 6.00065 11.3682 6.00065 11V7.66666C6.00065 7.29847 6.29913 6.99999 6.66732 6.99999ZM9.33398 6.99999C9.70217 6.99999 10.0007 7.29847 10.0007 7.66666V11C10.0007 11.3682 9.70217 11.6667 9.33398 11.6667C8.96579 11.6667 8.66732 11.3682 8.66732 11V7.66666C8.66732 7.29847 8.96579 6.99999 9.33398 6.99999Z"
                fill="#5D6983"
              />
            </svg>
          </span>
        </div>
      </div>
      } } @else {
      <div class="empty-container">
        <span>There are no available templates</span>
      </div>
      } } @else {
      <div class="loading-state">
        <p-progress-spinner
          strokeWidth="6"
          [style]="{ width: '40px', height: '40px' }"
        />
      </div>
      }
    </div>
  </div>
</p-popover>
@defer (when showDeleteConfirmation()) {
<lib-delete-template-modal
  [(loading)]="templateDeleteLoading"
  [(visible)]="showDeleteConfirmation"
  (confirm)="deleteTemplate()"
  title="Delete Template"
  description="Template will be deleted and all settings including sending
            schedule will not be saved. <br />Are you sure you want to delete
            the template?"
></lib-delete-template-modal>
} @if(showSendingModal()) {
<lib-send-settings-modal
  [(visible)]="showSendingModal"
  [selectedTemplate]="selectedTemplate"
></lib-send-settings-modal>
}
